import React from 'react'
import PropTypes from 'prop-types'
import {Tag, TagLabel} from '@chakra-ui/react'
import {camelize} from 'humps'
import {ExpandableTag} from '../../ExpandableTag'

const STATUS_COLOR = {
  processing: 'neutral',
  partiallyPaid: 'neutral',
  eligible: 'success',
  ineligible: 'alert',
}

const StatusBadge = ({lifecycleStatus, t}) => {
  const status = camelize(lifecycleStatus)
  const colorScheme = STATUS_COLOR[status]
  const label = t('bill.table.columns.body.status', {context: status})

  if (status === 'ineligible' || status === 'partiallyPaid') {
    const descriptionKey =
      status === 'ineligible'
        ? 'bill.table.columns.body.statusIneligibleDescription'
        : 'bill.table.columns.body.statusPartiallyPaidDescription'
    return (
      <ExpandableTag label={label} colorScheme={colorScheme}>
        {t(descriptionKey)}
      </ExpandableTag>
    )
  }

  return (
    <Tag variant="status" colorScheme={colorScheme}>
      <TagLabel>{label}</TagLabel>
    </Tag>
  )
}

StatusBadge.propTypes = {
  lifecycleStatus: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default StatusBadge
